const config = {
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  ENV: import.meta.env.VITE_ENV || 'local',
  API_BASE_URL: '/api/v1',
  API_CATALOGS_BASE_URL: '/api/v1/catalogs',
  API_CATALOGS_TOKEN:
    import.meta.env.VITE_API_CATALOGS_TOKEN ||
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYWRtaW4ifQ.rX0G5Wekw_282TAkp_j-hBDg_kOkY3gAXsmhzG0AJMQ',
  MOCK_INIT_DATA: '1',
  VITE_FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY || '',
  VITE_FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
  VITE_FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
  VITE_FIREBASE_STORAGE_BUCKET:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
  VITE_FIREBASE_MESSAGING_SENDER_ID:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  VITE_FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID || '',
  VITE_CHECKOUT_PUBLIC_KEY: import.meta.env.VITE_CHECKOUT_PUBLIC_KEY || '',
  VITE_CHECKOUT_BASE_URL: import.meta.env.VITE_CHECKOUT_BASE_URL || '',
  ENABLE_PHONE_SIGN_IN: import.meta.env.VITE_PHONE_SIGNIN_ENABLE || false,
  ENABLE_APPLE_SIGN_IN: import.meta.env.VITE_APPLE_SIGNIN_ENABLE || false,
  ENABLE_GOOGLE_SIGN_IN: import.meta.env.VITE_GOOGLE_SIGNIN_ENABLE || false,
  VITE_OPENAI_KEY: import.meta.env.VITE_OPENAI_KEY || '',
  // Boxo SDK Configuration
  VITE_BOXO_CLIENT_ID: import.meta.env.VITE_BOXO_CLIENT_ID || '',
  VITE_BOXO_SANDBOX_MODE: import.meta.env.VITE_BOXO_SANDBOX_MODE === 'true',
  VITE_BOXO_DEBUG: import.meta.env.VITE_BOXO_DEBUG === 'true',
  // Interlace Card Widget
  INTERLACE_WIDGET_URL: import.meta.env.VITE_INTERLACE_WIDGET_URL || '',
  // RAIN Card Provider Configuration
  RAIN_PUBLIC_KEY: import.meta.env.VITE_RAIN_PUBLIC_KEY || '',
  DEBUG_CONFIG: import.meta.env.VITE_DEBUG_CONFIG || {
      "all": false,
      "send-request": false,
      "api":false
  }
}

export default config

// Named export for cleaner imports
export const env = config
